import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type Bbfc15Props = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const Bbfc15 = ({ height = 35, sx, width = 35 }: Bbfc15Props) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 92.598" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M365.387 273.902h55.984v55.985h-55.984zm0 0" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.6541 0 0 1.6541 -604.389 -453.064)">
      <path
        d="M393.379 328.902c-14.918 0-27.012-12.093-27.012-27.011 0-14.914 12.094-27.008 27.012-27.008 14.914 0 27.008 12.094 27.008 27.008 0 14.918-12.094 27.011-27.008 27.011m0-55c-15.461 0-27.992 12.532-27.992 27.989 0 15.46 12.531 27.992 27.992 27.992 15.46 0 27.992-12.531 27.992-27.992 0-15.457-12.531-27.989-27.992-27.989"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M393.379 326.445c-13.563 0-24.555-10.992-24.555-24.55 0-13.563 10.992-24.555 24.555-24.555 13.559 0 24.555 10.992 24.555 24.555 0 13.558-10.996 24.55-24.555 24.55m0-51.562c-14.918 0-27.012 12.094-27.012 27.012 0 14.914 12.094 27.007 27.012 27.007 14.914 0 27.008-12.093 27.008-27.007 0-14.918-12.094-27.012-27.008-27.012"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -604.389 -453.064)"
    />
    <path
      d="M393.379 277.34c-13.563 0-24.555 10.992-24.555 24.55 0 13.563 10.992 24.555 24.555 24.555 13.559 0 24.555-10.992 24.555-24.554 0-13.559-10.996-24.551-24.555-24.551"
      style={{
        fill: '#eb5791',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -604.389 -453.064)"
    />
    <path
      d="M387.906 291.758v19.648h-3.582v-11.234c0-1.863 0-2.414-1.601-2.414h-3.2v-2.242h.375c1.836-.032 4.309-.059 5.098-3.758zM403.152 294.992h-7.656l-.668 4.336c.871-.875 2.27-1.457 3.785-1.457 3.492 0 5.965 2.594 5.965 6.55 0 4.048-2.648 7.25-7.305 7.25-1.308 0-2.59-.233-3.726-.816-2.738-1.457-2.942-3.988-3.027-4.949l4.074-.293c.09 2.012 1.34 2.914 2.824 2.914.672 0 1.25-.144 1.719-.465.87-.585 1.484-1.953 1.484-3.496 0-2.445-1.516-3.695-3.262-3.695-1.34 0-2.472.61-2.941 1.832l-3.285-.203 1.394-10.8h10.918zm0 0"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -604.389 -453.064)"
    />
  </SvgContainer>
);
